import React from 'react'
import { useTranslation } from 'react-i18next'

import CoverImageUpload from './components/CoverImageUpload'

const SystemSettingsTab = () => {
	const { t } = useTranslation()

	return (
		<div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
			<div>
				<h2 className="text-base/7 font-semibold text-gray-900">{t('settingsPage.system.title')}</h2>
				<p className="mt-1 text-sm/6 text-gray-500">{t('settingsPage.system.subtitle')}</p>
			</div>
			<div className="md:col-span-2">
				<div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
					<CoverImageUpload />
				</div>
			</div>
		</div>
	)
}

export default SystemSettingsTab
